import { useState } from "react";
import { Button } from "./ui/button";
import { Award, Loader2 } from "lucide-react";
import { patientApi } from "../services/api";
import { toast } from "sonner";

/**
 * Buton care generează numărul de viză medicală pentru un pacient.
 * Apare DOAR când toate cele 4 ateliere sunt marcate completat=true.
 * După apăsare, atelierele sunt resetate (completat=false) și fișa e arhivată,
 * iar butonul dispare până la următoarea completare.
 *
 * Props:
 *  patient        - obiect pacient (cu atelier_1..4)
 *  onGenerated    - callback(updatedPatient) după succes
 */
export const GenerateVizaButton = ({ patient, onGenerated }) => {
  const [loading, setLoading] = useState(false);

  if (!patient) return null;

  const allComplete = [1, 2, 3, 4, 5].every(
    (n) => patient[`atelier_${n}`]?.completat
  );

  if (!allComplete) return null;

  const handleClick = async () => {
    setLoading(true);
    try {
      const updated = await patientApi.generateNumarViza(patient.id);
      toast.success(`Număr de ordine generat: #${updated.numar_viza}`);
      if (onGenerated) onGenerated(updated);
    } catch (e) {
      toast.error(
        e?.response?.data?.detail || "Eroare la generarea numărului de ordine"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      disabled={loading}
      data-testid="generate-viza-button"
      className="gap-2 bg-emerald-600 hover:bg-emerald-700 text-white"
    >
      {loading ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : (
        <Award className="w-4 h-4" />
      )}
      Generează nr de ordine
    </Button>
  );
};
